'use strict';
/* ==========================================================================
   core-local/hooks.js — "Where Did Those Blue Eyes Come From?": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). The life-science cast (DESIGN.md §3).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js): Lily = pea-leaf green,
             Mr. Mendoza = nursery-pot terracotta (both dark enough to read on the dock's paper).
   completeCard: the INHERITED card: the finished step's card.done + where to go next (see below).
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   Puppets (DESIGN.md §3): lily (poses lily, lily_point) stands LEFT, mendoza (mendoza, mendoza_point) stands RIGHT.
            The pose aliases resolve at DRAW time: the pointing cut-out when it is loaded, else the standing one (else
            the engine's paper stand-in), so the scenes work before the art is in. Facing (Puppet.NATIVE): 0 = faces the
            front, never mirrored; ±1 = the way a pose points. From the chosen art (assets/ASSETS.md): lily front
            (clipboard held out), lily_point front (clipboard raised overhead), mendoza front (holding a pot),
            mendoza_point front (index finger raised): all four face the camera, so all are 0 (never mirrored).
   ========================================================================== */
window.LessonHooks = {
  speakers: { lily: { name: 'Lily', color: '#2f5a2a' }, mendoza: { name: 'Mr. Mendoza', color: '#8a3b1e' } },
  /* the INHERITED card. lesson.json's steps[].card.next describes the step AFTER that step ("video" → "Next: Punnett
     Lab (packet 2)."), so the next line is the finished step's own card.next when the first unstamped step is the one
     right after it; otherwise "Next: <title> (packet k)." (the engine's default card reads the unstamped step's own
     card.next, one step too far). */
  completeCard(stepId, progress) {
    const L = (window.Game && Game.lesson) || {}, steps = L.steps || [], C = L.completeCard || {}, st = progress.stamps || {};
    const me = steps.find(s => s.id === stepId) || {};
    const done = (me.card && me.card.done) || 'Inherited.';
    const k = steps.findIndex(s => !st[s.id]);
    let next;
    if (k < 0) next = C.allDone || 'All four inherited! Lesson complete.';
    else {
      const prev = steps[k - 1];
      next = prev && prev.id === stepId && prev.card && prev.card.next ? prev.card.next : `Next: ${steps[k].title || steps[k].id} (packet ${k + 1}).`;
    }
    return { title: C.title || 'INHERITED', lines: [done, next] };
  },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; DEFAULT = the standing pose), resolved per draw */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  const has = n => typeof IMG !== 'undefined' && !!IMG[n];
  const pick = (...names) => names.find(has) || names[names.length - 1];
  const poses = (me, point) => {
    const o = { [me]: me };
    Object.defineProperty(o, 'point', { enumerable: true, get: () => pick(point, me) });
    Object.defineProperty(o, point, { enumerable: true, get: () => pick(point, me) });
    return o;
  };
  P.POSES.lily = poses('lily', 'lily_point');
  P.POSES.mendoza = poses('mendoza', 'mendoza_point');
  P.DEFAULT.lily = 'lily';
  P.DEFAULT.mendoza = 'mendoza';
  Object.assign(P.NATIVE, { lily: 0, lily_point: 0, mendoza: 0, mendoza_point: 0 });
})();
